module.exports = __webpack_public_path__ + "static/img/Bin-Feng Yan.jpg";